import { LanguageEnum } from "enums/LanguageEnum";
import { createContext } from "react";
import { TranslationLabels } from "translations/TranslationLabels";

export type TranslationResourceObject<Language, TLabels> = {
  [key in Extract<Language, string>]: TLabels;
};

export interface TranslationsContextProps extends TranslationLabels {
  currentLanguage: LanguageEnum;
  allLanguages: LanguageEnum[];
  changeLanguage: (lang: LanguageEnum) => void;
}

export const TranslationsContext = createContext({} as TranslationsContextProps);
